import { useState, useEffect } from "react";

export default function useUploadMultiDocs() {
  const [dataDocs, setDataDocs] = useState([]);   // archivos válidos acumulados
  const [tempDocs, setTempDocs] = useState([]);   // último lote seleccionado
  const [errorFormatDocs, setErrorFormatDocs] = useState(false);
  const [errorLimit, setErrorLimit] = useState(false);

  const getExtensionFile = (filename) => {
    const lastDotIndex = filename.lastIndexOf(".");
    if (lastDotIndex === -1) return undefined;
    return filename.slice(lastDotIndex + 1).toLowerCase();
  };

  const uploadMultiDocs = (event, maxFiles) => {
    try {
      const filesUploaded = Array.from(event.target.files);
      setTempDocs(filesUploaded); // guardamos lo último que subió el user

      let validFiles = [];

      // Validar formatos
      filesUploaded.forEach((file) => {
        const ext = getExtensionFile(file.name);
        let condition;
        
        condition = ["dcom", "jpeg", "png", "jpg", "webp"].includes(ext);

        if (condition) {
          validFiles.push(file);
        }
      });

      // Combinar archivos actuales + nuevos
      const combined = [...dataDocs, ...validFiles];

      // Validar límite
      if (combined.length > maxFiles) {
        setErrorLimit(true);
        // Cortar a la cantidad permitida
        setDataDocs(combined.slice(0, maxFiles));
      } else {
        setErrorLimit(false);
        setDataDocs(combined);
      }

      // Si algún archivo no pasó la validación de formato
      setErrorFormatDocs(validFiles.length !== filesUploaded.length);
    } catch (err) {
      console.log(err);
    }
  };

  const deleteDocs = () => {
    setDataDocs([]);
    setTempDocs([]);
  };

  const clearDocs = () => {
    setDataDocs([]);
    setTempDocs([]);
    setErrorFormatDocs(false);
    setErrorLimit(false);
  };

  return {
    dataDocs,     // archivos acumulados
    tempDocs,     // último lote seleccionado
    errorFormatDocs,
    uploadMultiDocs,
    deleteDocs,
    errorLimit,
    clearDocs,
  };
}